import { render, staticRenderFns } from "./MaterialMayorHistorialSection.vue?vue&type=template&id=5520683d&scoped=true&"
import script from "./MaterialMayorHistorialSection.vue?vue&type=script&lang=js&"
export * from "./MaterialMayorHistorialSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5520683d",
  null
  
)

export default component.exports